import React, { useContext } from 'react';
import { AuthStore } from './contexts/auth';

import { PusherProvider, PusherStore } from './contexts/pusher';

export interface ProviderProps {
  children: React.ReactNode;
}

const StoreProvider = ({ children }: ProviderProps) => (
  <PusherProvider>
    {children}
  </PusherProvider>
);

export const useAuthStore = () => useContext(AuthStore);
export const usePusherStore = () => useContext(PusherStore);

export default StoreProvider;
